export default [
  { name: 'Content', prop: 'content', type: 'wysiwyg' }
]
